import Popper from '../Popper/Popper.js';

/** @deprecated */

var Dropdown = Popper;

export { Dropdown as default };
